import { RoofContainer } from '@paragon/contract-library';
import { designService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { layoutSlice } from '../../slices/layoutSlice';
import { AsyncThunkActionVoid } from '../thunkActions';

export const updateRoofContainer =
  (roofContainer: RoofContainer): AsyncThunkActionVoid =>
  async (dispatch, getState) => {
    const state = getState();
    if (state.application.openContext?.type !== 'project') {
      dispatch(enqueueError('Cannot update project outside of a project.'));
      return;
    }

    const spinnerId = dispatch(addSpinnerMessage('Saving roof container...'));

    try {
      await designService.projects.upsertRoofContainer(state.application.openContext.projectGuid, roofContainer);
    } catch (error) {
      console.error(error);
      dispatch(enqueueError('Unable to save roof container. Please try again or contact Paragon Customer Support.'));

      return;
    } finally {
      dispatch(removeSpinnerMessage(spinnerId));
    }

    dispatch(layoutSlice.actions.roofContainerUpserted(roofContainer));
  };
